/*
 * Raw brand color values for JS/SVG consumers that can't resolve a CSS var()
 * — e.g. SVG presentation attributes (<svg fill>).
 *
 * MUST mirror the corresponding custom properties in styles/tokens.css, which
 * remains the single source of truth for all CSS. Prefer var(--…) everywhere
 * it works (CSS, inline style, MUI sx); only reach for these constants when a
 * value is consumed as an SVG attribute.
 */
export const BRAND_COBALT = '#3950A0';
export const BRAND_COBALT_DEEP = '#263780';
export const BRAND_COBALT_LITE = '#7B96E8';
export const CYAN = '#3FC2C2';
export const ACCENT_FIRE = '#FF5C3A';
export const ACCENT_GOLD = '#F5B800';
export const INK = '#0C0F1E';
export const WHITE = '#FFFFFF';
export const N600 = '#5C6480';
export const N800 = '#2A2F47';
